import request from "@/utils/request";

export default function agentGetNoCarCardByCardId(cardId) {
  return request({
    url: `/user/card/agentGetNoCarCardByCardId/${cardId}`,
  });
}
